module.exports = __webpack_public_path__ + "static/media/Klefki_gaussian2.b4654fa0.png";